import { Store } from "@ngrx/store";
import { distinctUntilChanged, filter, Observable } from "rxjs";
import * as AuthSelectors from "../+state/auth.selectors";

/**
 * Emits the active account id on initial subscription and on every genuine business/company switch.
 *
 * Use this to drive in-place data reloads when the active business changes while the user stays on the
 * same page (no navigation, so Ionic lifecycle hooks don't re-fire). Emits the current id immediately,
 * so it also covers the initial load.
 *
 * Standard page usage (recreate the teardown Subject on each `ionViewDidEnter` — see home.page.ts):
 *   ionViewDidEnter() {
 *     this.leave$ = new Subject<void>();
 *     activeAccountChanges(this.store).pipe(takeUntil(this.leave$)).subscribe(() => this.loadData());
 *   }
 *   ionViewDidLeave() { this.leave$.next(); this.leave$.complete(); }
 */
export function activeAccountChanges(store: Store): Observable<string> {
  return store.select(AuthSelectors.selectActiveAccountId).pipe(
    distinctUntilChanged(),
    filter((id): id is string => !!id)
  );
}
